<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageInterfaces.title') }}
    </portal>
    <template>
      <card :title="$t('admin.pageInterfaces.card.interfaces')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <hm-card-inner-line v-if="hasLicense('InterfaceHotelSpider')"
                                :clickable="true"
                                :title="hotelSpiderName"
                                @click="$router.push({ name: 'interfaces.hotelSpider'})" />
            <template v-if="hasLicense('InterfaceCmConnectCX') && (['Hotelmeister','AllInOne'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))">
              <template v-for="cxId in channexIds">
                <hm-card-inner-line :clickable="true"
                                    :key="cxId"
                                    title="Connect.CX"
                                    @click="$router.push({ name: 'interfaces.connectCX', params: {configId: cxId}})" />
              </template>
            </template>
            <hm-card-inner-line v-if="hasLicense('InterfaceCmConnectS') && (['Hotelmeister','Rainmaker'].includes(hotelSettings.hotel.whiteLabel) || hasRole('ROLE_SYSADMIN'))"
                                :clickable="true"
                                title="Connect.S"
                                @click="$router.push({ name: 'interfaces.connectS'})" />
            <template v-if="hasLicense('InterfaceInteralpSalesbox')">
              <hm-card-inner-line v-for="it in salesboxIds"
                                  :key="it"
                                  :clickable="true"
                                  title="Salesbox"
                                  @click="$router.push({ name: 'interfaces.interalpSalesbox', params: { interfaceId: it }})" />
            </template>
            <hm-card-inner-line v-if="hasLicense('iCalImport')"
                                :clickable="true"
                                title="iCal"
                                @click="$router.push({ name: 'interfaces.iCal'})" />
            <hm-card-inner-line v-if="hasLicense('GenericPOS')"
                                :clickable="true"
                                :title="$t('admin.pageInterfaces.genericPos')"
                                @click="$router.push({ name: 'interfaces.genericPos'})" />
            <template v-if="hasLicense('InterfaceMeldeblatt')">
              <hm-card-inner-line v-for="it in meldeclients"
                                  :key="it.id"
                                  :clickable="true"
                                  :title="`${it.name || $t('layout.nav.admin.interfaceNav.printFeratel')} (${$t(`MeldeclientTyp.${it.type}`)})`"
                                  @click="$router.push({ name: 'interfaces.meldeclient', params: { interfaceId: it.id }})" />
            </template>
            <hm-card-inner-line v-if="hasLicense('InterfaceATrustRegMobile')"
                                :clickable="true"
                                :title="$t('admin.pageInterfaces.aTrustRegMobile')"
                                @click="$router.push({ name: 'interfaces.aTrustRegMobile'})" />
            <template v-if="hasLicense('ExchangeRates') && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
              <hm-card-inner-line :clickable="true"
                                  :title="$t('admin.pageInterfaces.exchangeRates')"
                                  @click="$router.push({ name: 'interfaces.exchangeRates'})" />
            </template>
            <template v-if="hasLicense('InterfaceFiskaltrustDE') || (hasRole('ROLE_SYSADMIN') && hotelSettings.details.countryCode === 'DE')">
              <hm-card-inner-line :clickable="true"
                                  :title="$t('admin.pageInterfaces.fiskaltrustDE')"
                                  @click="$router.push({ name: 'interfaces.fiskaltrustDE'})" />
            </template>
            <template v-if="hasLicense('InterfaceMollie') || hasLicense('InterfaceStripe') || hasLicense('InterfaceFanz')">
              <hm-card-inner-line v-if="hasLicense('InterfaceStripe')"
                                  :clickable="true"
                                  :title="$t('admin.pageInterfaces.stripe')"
                                  @click="$router.push({ name: 'interfaces.stripe'})" />
              <hm-card-inner-line v-if="hasLicense('InterfaceFanz')"
                                  :clickable="true"
                                  :title="$t('admin.pageInterfaces.fanz')"
                                  @click="$router.push({ name: 'interfaces.fanz'})" />
              <hm-card-inner-line v-if="hasLicense('InterfaceMollie')"
                                  :clickable="true"
                                  :title="$t('admin.pageInterfaces.mollie')"
                                  @click="$router.push({ name: 'interfaces.mollie'})" />
            </template>
            <template v-if="hasLicense('InterfaceCharPmsLink')">
              <template v-for="configId in charPmsLinkIds">
                <hm-card-inner-line :clickable="true"
                                    :key="configId"
                                    :title="$t('admin.pageInterfaces.charPmsLink')"
                                    @click="$router.push({ name: 'interfaces.charPmsLink', params: { configId: configId }})" />
              </template>
            </template>
            <template v-if="hasAnyLicense(['LockingSystems'])">
              <hm-card-inner-line :clickable="true"
                                  :title="$t('admin.pageInterfaces.locking')"
                                  @click="$router.push({ name: 'interfaces.locking'})" />
            </template>
            <template v-if="hasAnyLicense(['InterfaceSmartpricing'])">
              <hm-card-inner-line :clickable="true"
                                  :title="$t('admin.pageInterfaces.smartpricing')"
                                  @click="$router.push({ name: 'interfaces.smartpricing'})" />
            </template>
            <template v-if="hasLicense('PaymentRequests')">
              <hm-card-inner-line v-if="hasLicense('PaymentRequests')"
                                  :clickable="true"
                                  :title="$t('admin.pageInterfaces.paymentRequest')"
                                  @click="$router.push({ name: 'interfaces.paymentRequest'})" />
            </template>
            <template v-if="hasLicense('OnlineBooking')">
              <hm-card-inner-line v-if="hasLicense('OnlineBooking')"
                                  :clickable="true"
                                  :title="$t('admin.pageInterfaces.onlineBooking')"
                                  @click="$router.push({ name: 'interfaces.onlineBooking'})" />
            </template>
            <template v-if="hasLicense('Kiosk')">
              <hm-card-inner-line v-if="hasLicense('Kiosk')"
                                  :clickable="true"
                                  :title="$t('admin.pageInterfaces.kiosk')"
                                  @click="$router.push({ name: 'interfaces.kiosk'})" />
            </template>
            <template v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
              <hm-card-inner-line :clickable="true"
                                  :title="$t('admin.pageInterfaces.logs')"
                                  @click="$router.push({ name: 'interfaces.logs'})" />
              <hm-card-inner-line v-if="hasLicense('InterfaceCmConnectS')"
                                  :clickable="true"
                                  title="Logs (Connect.S)"
                                  @click="$router.push({ name: 'interfaces.connectSlogs'})" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <template v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
        <hm-floating-buttons>
          <hm-floating-button label="Add interface" icon="plus" color="blue">
            <hm-floating-child-button :throttle="5000"
                                      label="Add char pmslink interface"
                                      icon="plus"
                                      color="blue"
                                      @click="addCharPmsLinkInterface" />
            <hm-floating-child-button :throttle="5000"
                                      label="Add Salesbox interface"
                                      icon="plus"
                                      color="blue"
                                      @click="addInteralpSalesbox" />
            <hm-floating-child-button :throttle="5000"
                                      label="Add Meldeclient interface"
                                      icon="plus"
                                      color="blue"
                                      @click="addMeldeclient" />
          </hm-floating-button>
        </hm-floating-buttons>
      </template>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmFloatingButtons from '../../lib/inputs/HmFloatingButtons';
import ItemNavGroup from '../../lib/layout/nav/ItemNavGroup.vue';
import ItemNavGroupItem from '../../lib/layout/nav/ItemNavGroupItem.vue';

export default {
  name: 'PageInterfaces',
  components: {
    ItemNavGroupItem,
    ItemNavGroup,
    HmFloatingButtons },
  mixins: [HotelmeisterMixin],

  data() {
    return {
      meldeclients: [],
      salesboxIds: [],
      channexIds: [],
      charPmsLinkIds: [],
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.meldeclient.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            // this.meldeclientIds = response.data.data.map(it => it.id);
            this.meldeclients = response.data.data.map(it => ({ id: it.id, name: it.name, type: it.typ }));
          }
        });
      this.axios.get(this.serviceUrls.interfaces.interalpSalesbox.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.salesboxIds = response.data.data.map(it => it.id);
          }
        });
      this.axios.get(this.serviceUrls.interfaces.channelManagerCx.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.channexIds = response.data.data.map(it => it.id);
          }
        });
      this.axios.get(this.serviceUrls.interfaces.charPmsLink.list(this))
        .then((response) => {
          if (isNil(this.config)) {
            this.charPmsLinkIds = response.data.data.map(it => it.id);
          }
        });
    },
    addCharPmsLinkInterface() {
      this.axios.post(this.serviceUrls.interfaces.charPmsLink.create(this), { })
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        })
        .finally(() => {
          this.loadData();
          this.$serviceBus.$emit('interface.list');
        });
    },
    addInteralpSalesbox() {
      this.axios.post(this.serviceUrls.interfaces.interalpSalesbox.create(this), { })
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        })
        .finally(() => {
          this.loadData();
          this.$serviceBus.$emit('interface.list');
        });
    },
    addMeldeclient() {
      this.axios.post(this.serviceUrls.interfaces.meldeclient.create(this), { })
        .then((response) => {
          this.showMessages(response);
          this.showSuccessMessage();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        })
        .finally(() => {
          this.loadData();
          this.$serviceBus.$emit('interface.list');
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageInterfaces.vue